// Models
import { FullAgentResponse } from 'app/modules/agents/responses';

export enum UploadsActionTypes {
  UPLOAD_DATAFILE_ASYNC = '@@uploads/UPLOAD_DATAFILE_ASYNC',
  UPLOAD_DATAFILE_ASYNC_SUCCESS = '@@uploads/UPLOAD_DATAFILE_ASYNC_SUCCESS',
  UPLOAD_DATAFILE_ASYNC_ERROR = '@@uploads/UPLOAD_DATAFILE_ASYNC_ERROR',

  RETRIEVE_DATAFILES = '@@uploads/RETRIEVE_DATAFILES',
  RETRIEVE_DATAFILES_SUCCESS = '@@uploads/RETRIEVE_DATAFILES_SUCCESS',

  DELETE_DATAFILE = '@@uploads/DELETE_DATAFILE',
  DELETE_DATAFILE_SUCCESS = '@@uploads/DELETE_DATAFILE_SUCCESS',

  SET_FILES_TO_UPLOAD = '@@uploads/SET_FILES_TO_UPLOAD',
  SET_FILES_TO_UPLOAD_ASYNC = '@@uploads/SET_FILES_TO_UPLOAD_ASYNC',

  SET_FILE_UPLOAD_PROGRESS = '@@uploads/SET_FILE_UPLOAD_PROGRESS',

  PROCESS_DATAFILE = '@@uploads/PROCESS_DATAFILE',
  PROCESS_DATAFILE_SUCCESS = '@@uploads/PROCESS_DATAFILE_SUCCESS',
}

export interface Upload {
  id: number;
  created_at: string | null;
  url: string;
  org_id?: number;
  org_name?: string;
  unit_id?: number;
  uploaded_by?: FullAgentResponse;
  status: UploadStatus;
  original_file_name: string;
  custom_data?: JSONObject;
  status_message?: string;
  file_size?: number;
  percent?: number;
  xhr?: any;
}

export enum UploadStatus {
  AWAITING_TRIGGER = 'AWAITING_TRIGGER',
  VALIDATION_PENDING = 'VALIDATION_PENDING',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  PROCESS_PENDING = 'PROCESS_PENDING',
  PROCESS_SUCCESS = 'PROCESS_SUCCESS',
  PROCESS_FAILED = 'PROCESS_FAILED',
  OTHER_FAILED = 'OTHER_FAILED',

  // UI only status
  UPLOADING = 'UPLOADING',
  UPLOAD_FAILED = 'UPLOAD_FAILED',
  UPLOAD_ABORTED = 'UPLOAD_ABORTED',
}

export interface FileToUpload {
  status: string;
  name: string;
  path?: string;
  size: number;
  errorMessage?: string;
  binary?: File;
}

export interface DatafilesListResponse {
  count: number;
  unprocessed_count: number;
  files: Upload[];
}

export interface UploadState {
  count: number;
  unprocessedCount: number;
  uploads: Upload[];
  filesToUploadAsync: Upload[];
  filesToUpload: FileToUpload[];
}

export interface RetrieveFilesPayload {
  offset: number;
  limit: number;
  agent_ids?: number[];
  statuses?: string[];
  start_date?: string;
  end_date?: string;
  sort_column?: string;
  sort_direction?: string;
}

export interface UploadDatafile {
  file: File;
}
export interface UploadFileProgress {
  file: File;
  percent: number;
  total: number;
  loaded: number;
  xhr?: any;
}

export interface UploadFilesPayload {
  id: string;
  files: File[];
}
